import { DRMConfig } from 'bitmovin-player';

import { getDrmCertificatesUrl, getDrmLicensesUrl } from 'config/api.ts';

export const getBitmovinDrmConfig = (
    contentToken: string | undefined,
): DRMConfig | undefined => {
    return contentToken
        ? {
              immediateLicenseRequest: true,
              widevine: {
                  LA_URL: getDrmLicensesUrl(),
              },
              fairplay: {
                  LA_URL: getDrmLicensesUrl(),
                  certificateURL: getDrmCertificatesUrl(),
                  useUint16InitData: true,
                  prepareLicense(data) {
                      return data;
                  },
                  prepareMessage(event) {
                      return event.message;
                  },
                  prepareContentId(url) {
                      const jsonStr = window.atob(
                          url.split('skd://')[1].split('?')[0],
                      );
                      const { ContentId, KeyId } = JSON.parse(jsonStr);

                      return JSON.stringify({
                          contentRef: ContentId,
                          KeyId,
                      });
                  },
              },
          }
        : undefined;
};
